import { ReactNode } from 'react';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface LabeledFieldProps {
  label: string;
  children: ReactNode;
}

export function LabeledField({ label, children }: LabeledFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <Typography variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-bold">
        {label}
      </Typography>
      {children}
    </div>
  );
}
